(function() {
  ko.bindingHandlers.checkableButton = {
    init: function(element, valueAccessor, allBindingsAccessor, viewModel) {
      $(element).on('click', (function(_this) {
        return function() {
          var val, value;
          value = valueAccessor();
          val = ko.unwrap(value);
          return value(!val);
        };
      })(this));
      return ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
        return $(element).off('click');
      });
    },
    update: function(element, valueAccessor, allBindingsAccessor, viewModel) {
      var ref, val;
      val = ko.unwrap((ref = valueAccessor()) != null ? ref : {});
      if (val) {
        return $(element).removeClass("ko-checkableButton-unchecked");
      } else {
        return $(element).addClass('ko-checkableButton-unchecked');
      }
    }
  };

}).call(this);
